import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.workspace.item');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-workspace-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.workspace.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabWorkspaceItemComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() workspace_id: string = '';
    @Input() tab: string = '';
    @Input() detail_id: string = '';

    public ws: any = null;
    public members: any[] = [];
    public activities: any[] = [];
    public stats: any = { member_count: 0, activity_count: 0 };
    public myRole: string = '';
    public loaded: boolean = false;

    public currentTab: string = 'overview';
    public tabs: any[] = [
        { key: 'overview', title: '개요' },
        { key: 'members', title: '멤버' },
        { key: 'activity', title: '활동' },
        { key: 'settings', title: '설정' },
    ];

    // member invite
    public showInvite: boolean = false;
    public inviteSearchText: string = '';
    public candidateUsers: any[] = [];

    // settings edit form
    public editForm: any = { name: '', description: '', visibility: 'private', color: 'rose' };
    public colors: string[] = ['rose', 'blue', 'emerald', 'violet', 'amber'];
    public roleOptions: string[] = ['owner', 'manager', 'member', 'guest'];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['workspace_id'] && !changes['workspace_id'].firstChange) {
            await this.load();
        }
        if (changes['tab']) {
            this.currentTab = this.tab || 'overview';
            await this.service.render();
        }
    }

    public async load() {
        if (!this.workspace_id) return;
        const res = await wiz.call("info", { id: this.workspace_id });
        if (res.code === 200) {
            this.ws = res.data.workspace;
            this.members = res.data.members || [];
            this.activities = res.data.activities || [];
            this.stats = res.data.stats || this.stats;
            this.myRole = res.data.my_role || '';
            this.editForm = {
                name: this.ws.name,
                description: this.ws.description || '',
                visibility: this.ws.visibility,
                color: this.ws.color || 'rose',
            };
        } else if (res.code === 403) {
            this.service.alert.error("접근 권한이 없습니다.");
            this.service.href("/admin/collab/workspace");
            return;
        } else {
            this.service.alert.error(res.data?.message || "워크스페이스를 불러올 수 없습니다.");
        }
        this.currentTab = this.tab || 'overview';
        this.loaded = true;
        await this.service.render();
    }

    public switchTab(key: string) {
        this.service.href(`/admin/collab/workspace/${this.workspace_id}/${key}`);
    }

    public goList() {
        this.service.href(`/admin/collab/workspace`);
    }

    public canManage(): boolean {
        return this.myRole === 'owner' || this.myRole === 'manager';
    }

    public canOwn(): boolean {
        return this.myRole === 'owner';
    }

    // -------- Members --------
    public async openInvite() {
        this.showInvite = true;
        this.inviteSearchText = '';
        this.candidateUsers = [];
        await this.searchUsers();
    }

    public closeInvite() {
        this.showInvite = false;
    }

    public async searchUsers() {
        const res = await wiz.call("user_search", { text: this.inviteSearchText });
        if (res.code === 200) {
            const memberIds = new Set(this.members.map(m => m.user_id));
            this.candidateUsers = (res.data.rows || []).filter((u: any) => !memberIds.has(u.id));
            await this.service.render();
        }
    }

    public async invite(u: any, role: string = 'member') {
        const res = await wiz.call("member_add", { id: this.workspace_id, user_id: u.id, role });
        if (res.code === 200) {
            this.service.alert.success(`${u.name}님을 초대했습니다.`);
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "초대 실패");
        }
    }

    public async changeRole(m: any, role: string) {
        if (m.role === role) return;
        const res = await wiz.call("member_role", { id: this.workspace_id, user_id: m.user_id, role });
        if (res.code === 200) {
            m.role = role;
            await this.service.render();
        } else {
            this.service.alert.error(res.data?.message || "역할 변경 실패");
        }
    }

    public async removeMember(m: any) {
        const ok = await this.service.alert.show({
            title: "멤버 제거",
            message: `${m.name}님을 워크스페이스에서 제거하시겠습니까?`,
            actionBtn: "danger", action: "제거", cancel: "취소",
        });
        if (!ok) return;
        const res = await wiz.call("member_remove", { id: this.workspace_id, user_id: m.user_id });
        if (res.code === 200) {
            this.members = this.members.filter(x => x.user_id !== m.user_id);
            this.stats.member_count = this.members.length;
            await this.service.render();
        } else {
            this.service.alert.error(res.data?.message || "제거 실패");
        }
    }

    // -------- Settings --------
    public async saveSettings() {
        if (!this.editForm.name || !this.editForm.name.trim()) {
            this.service.alert.error("이름은 필수입니다.");
            return;
        }
        const res = await wiz.call("update", {
            id: this.workspace_id,
            name: this.editForm.name,
            description: this.editForm.description,
            visibility: this.editForm.visibility,
            color: this.editForm.color,
        });
        if (res.code === 200) {
            this.service.alert.success("저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "저장 실패");
        }
    }

    public async archiveWs() {
        const ok = await this.service.alert.show({
            title: "워크스페이스 보관",
            message: "보관된 워크스페이스는 목록에서 숨겨지지만 데이터는 유지됩니다.",
            actionBtn: "danger", action: "보관", cancel: "취소",
        });
        if (!ok) return;
        const res = await wiz.call("archive", { id: this.workspace_id });
        if (res.code === 200) {
            this.service.alert.success("보관 완료");
            this.service.href("/admin/collab/workspace");
        } else {
            this.service.alert.error(res.data?.message || "실패");
        }
    }

    public roleLabel(role: string): string {
        const m: any = { owner: '소유자', manager: '관리자', member: '멤버', guest: '게스트' };
        return m[role] || role;
    }
}

export default PortalLpsysadminCollabWorkspaceItemComponent;